/**
 * Flattens hierarchical browse category config for slug lookup, sitemaps, and server redirects.
 * Each node with `slug` + `enumOption` becomes one row; optional `children` are visited recursively.
 *
 * @param {Array<object>} rows
 * @param {Array<object>} acc
 * @returns {Array<{ slug: string, enumOption: string, keywords?: string, label?: string }>}
 */
export function flattenBrowseCategoryConfig(rows, acc = []) {
  if (!Array.isArray(rows)) {
    return acc;
  }
  for (const row of rows) {
    if (!row || typeof row !== 'object') {
      continue;
    }
    if (row.slug && row.enumOption) {
      const entry = {
        slug: String(row.slug),
        enumOption: String(row.enumOption),
      };
      if (Array.isArray(row.keywords) && row.keywords.length > 0) {
        entry.keywords = row.keywords;
      } else if (row.keywords != null && String(row.keywords).trim() !== '') {
        entry.keywords = String(row.keywords).trim();
      }
      if (row.label != null && String(row.label).trim() !== '') {
        entry.label = String(row.label).trim();
      }
      acc.push(entry);
    }
    if (Array.isArray(row.children) && row.children.length > 0) {
      flattenBrowseCategoryConfig(row.children, acc);
    }
  }
  return acc;
}
